import {
  Box,
  Dialog,
  DialogContent,
  IconButton,
  Typography,
  Button,
} from "@material-ui/core";
import { Cancel } from "@material-ui/icons";
import { useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

function PDFViewer({ file, handleClosed, open }) {
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [scale, setScale] = useState(1);

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  return (
    <Dialog
      open={open}
      onClose={handleClosed}
      aria-describedby="alert-dialog-description"
      style={{ width: "90%" }}
    >
      <DialogContent>
        {/* <Box>
          <IconButton style={{ top: "0", left: "0" }} onClick={handleClosed}>
            <Cancel />
          </IconButton>
        </Box>
        <Box style={{}}>
          <IconButton style={{}} onClick={() => setScale((s) => s + 1)}>
            <AddCircleIcon />
          </IconButton>
          <IconButton
            style={{ position: "fixed" }}
            onClick={() => setScale((s) => s - 1)}
          >
            <RemoveCircleIcon />
          </IconButton>
        </Box>
        <Box> */}
        {/* <Document file={file} onLoadSuccess={onDocumentLoadSuccess}>
                        <Page
                            scale={scale}
                            renderAnnotationLayer={false}
                            pageNumber={pageNumber}

                        />
                    </Document>              */}
        <iframe
          title="Document"
          src={file}
          // width="100%"
          height="500px"
        ></iframe>
        {/* </Box>
        <Box style={{ textAlign: "center" }}>
          <Typography>
            Page {pageNumber} of {numPages}
          </Typography>
        </Box>
        <Box style={{ display: "flex", flexDirection: "row" }}>
          <Button
            variant="outlined"
            style={{
              backgroundColor: "white",
              borderColor: "#0F589D",
              color: "black",
              padding: "8px 14px",
              textAlign: "center",
              textDecoration: "none",
              display: "inline-block",
              fontSize: "13px",
              borderRadius: "12px",
              textTransform: "none",
              marginLeft: "5%",
            }}
            disabled={pageNumber === 1}
            onClick={() => setPageNumber((p) => Math.max(1, p - 1))}
          >
            Previous
          </Button>
          <Button
            style={{
              backgroundColor: "#0F589D",
              border: "none",
              color: "white",
              padding: "12px 18px",
              textAlign: "center",
              textDecoration: "none",
              display: "inline-block",
              fontSize: "12px",
              borderRadius: "12px",
              textTransform: "none",
              marginTop: "0px",
              marginRight: "5%",
              marginLeft: "auto",
              "&:hover": {
                backgroundColor: "#0F589D",
                border: "none",
                color: "white",
              },
            }}
            disabled={pageNumber === numPages}
            onClick={() => setPageNumber((p) => Math.min(numPages, p + 1))}
          >
            Next
          </Button>
        </Box> */}
      </DialogContent>
    </Dialog>
  );
}

export default PDFViewer;
